import React, { useContext, useCallback } from 'react';
import { INCIDENT_STATUS } from '@silverfort-nodelibs/common/utils/consts';
import OverviewCard from '../../OverviewCard/OverviewCard';
import useGetIncidentsStatusOverview from '../../api/queries/useGetIncidentsStatusOverview';
import ItdrContext from '../../ItdrContext';
import { LAST_CHANGES_FILTERS } from '../Filters';
import { addOrRemoveIfPresentFromArray } from '../../../../utils/utils';

const IncidentsByStatus = () => {
    const { lastActivityDiffInDays, setSelectedStatuses } = useContext(ItdrContext);
    const { isFetching: loadingStatusOverview, data: statusOverview } = useGetIncidentsStatusOverview({
        lastActivityFilterInDays: lastActivityDiffInDays ?? LAST_CHANGES_FILTERS.LAST_DAY
    });

    const onItemSelected = useCallback((statusValue: number) => {
        setSelectedStatuses(prev => addOrRemoveIfPresentFromArray(statusValue, prev));
    }, [setSelectedStatuses]);

    return (
        <OverviewCard
            title="Incidents by Status"
            items={[
                {
                    ...INCIDENT_STATUS.OPEN,
                    count: statusOverview?.[INCIDENT_STATUS.OPEN.value] ?? 0,
                    color: INCIDENT_STATUS.OPEN.textColor,
                    onClick: () => onItemSelected(INCIDENT_STATUS.OPEN.value)
                },
                {
                    ...INCIDENT_STATUS.IN_PROGRESS,
                    count: statusOverview?.[INCIDENT_STATUS.IN_PROGRESS.value] ?? 0,
                    color: INCIDENT_STATUS.IN_PROGRESS.textColor,
                    onClick: () => onItemSelected(INCIDENT_STATUS.IN_PROGRESS.value)
                },
                {
                    ...INCIDENT_STATUS.RESOLVED,
                    count: statusOverview?.[INCIDENT_STATUS.RESOLVED.value] ?? 0,
                    color: INCIDENT_STATUS.RESOLVED.textColor,
                    onClick: () => onItemSelected(INCIDENT_STATUS.RESOLVED.value)
                }
            ]}
            isLoading={loadingStatusOverview}
        />
    );
};

export default IncidentsByStatus;
